
import { Component, Prop, Watch, BaseMixins, Provide } from "@/lib";

@Component({ name: "card-title" })
export default class CardTitleView extends BaseMixins {
  @Prop({ type: String, required: true }) text: string;

  get labelText() {
    return this.L(this.text);
  }
}
